module.exports = __webpack_public_path__ + "static/img/banner_f003.a26c179.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner_f003.jpg
// module id = ic2N
// module chunks = 40